import React from 'react'
import {
  withRouter
} from 'react-router-dom'
import {
  Table,
} from 'semantic-ui-react'
import Tier from './Tier.js'
import OptionalSelectTableHeaderCell from './OptionalSelectTableHeaderCell.js'
import OptionalItemSelectorCell from './OptionalItemSelectorCell.js'
import OptionalCompareTableHeaderCells from './OptionalCompareTableHeaderCells.js'
import OptionalCompareItemCells from './OptionalCompareItemCells.js'

const TopicTable = ({ history, topics, mode, selection, selections, chosenFqid, comparisonMode, comparisonSelectionNames, onToggle }) => {
  const rows = [];
  topics.forEach((topic)=>{
    rows.push(
      <Table.Row key={topic.fqid} id={topic.fqid} warning={topic.fqid===chosenFqid}>
        <Table.Cell disabled collapsing>{topic.id}</Table.Cell>
        <Table.Cell colSpan='3' onClick={()=>history.push("/fqid/"+topic.fqid)}>{topic.name}</Table.Cell>
        <Table.Cell collapsing textAlign="right"><Tier tier={topic.tier}/></Table.Cell>
        <OptionalItemSelectorCell mode={mode} selection={selection} onToggle={onToggle} fqid={topic.fqid}/>
        <OptionalCompareItemCells
          mode={mode}
          comparisonMode={comparisonMode}
          comparisonSelectionNames={comparisonSelectionNames}
          selections={selections}
          fqidPrefix={topic.fqid}
        />
      </Table.Row>
    );
    topic.topics && topic.topics.forEach((subtopic, subtopicIndex)=>{
      rows.push(
        <Table.Row key={subtopic.fqid} id={subtopic.fqid} warning={subtopic.fqid===chosenFqid}>
          <Table.Cell disabled collapsing>{topic.id}.{subtopic.id}</Table.Cell>
          <Table.Cell collapsing>&bull;</Table.Cell>
          <Table.Cell colSpan='2' onClick={()=>history.push("/fqid/"+subtopic.fqid)}>{subtopic.name}</Table.Cell>
          <Table.Cell collapsing textAlign="right"><Tier tier={subtopic.tier}/></Table.Cell>
          <OptionalItemSelectorCell mode={mode} selection={selection} onToggle={onToggle} fqid={subtopic.fqid}/>
          <OptionalCompareItemCells
            mode={mode}
            comparisonMode={comparisonMode}
            comparisonSelectionNames={comparisonSelectionNames}
            selections={selections}
            fqidPrefix={subtopic.fqid}
          />
        </Table.Row>
      );
      subtopic.topics && subtopic.topics.forEach((subsubtopic, subsubtopicIndex)=>{
        rows.push(
          <Table.Row key={subsubtopic.fqid} id={subsubtopic.fqid} warning={subsubtopic.fqid===chosenFqid}>
            <Table.Cell disabled collapsing>{topic.id}.{subtopic.id}.{subsubtopic.id}</Table.Cell>
            <Table.Cell collapsing></Table.Cell>
            <Table.Cell collapsing>-</Table.Cell>
            <Table.Cell onClick={()=>history.push("/fqid/"+subsubtopic.fqid)}>{subsubtopic.name}</Table.Cell>
            <Table.Cell collapsing textAlign="right"><Tier tier={subsubtopic.tier}/></Table.Cell>
            <OptionalItemSelectorCell mode={mode} selection={selection} onToggle={onToggle} fqid={subsubtopic.fqid}/>
            <OptionalCompareItemCells
              mode={mode}
              comparisonMode={comparisonMode}
              comparisonSelectionNames={comparisonSelectionNames}
              selections={selections}
              fqidPrefix={subsubtopic.fqid}
            />
          </Table.Row>
        );
      });
    });
  });
  return (
    <Table compact='very' basic='very' selectable>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell collapsing/>
          <Table.HeaderCell colSpan='3'>
            Name
          </Table.HeaderCell>
          <Table.HeaderCell collapsing>
            Tier
          </Table.HeaderCell>
          <OptionalSelectTableHeaderCell mode={mode} selection={selection}/>
          <OptionalCompareTableHeaderCells
            mode={mode}
            comparisonMode={comparisonMode}
            comparisonSelectionNames={comparisonSelectionNames}
            selections={selections}
          />
        </Table.Row>
      </Table.Header>
      <Table.Body>
        { rows }
      </Table.Body>
    </Table>
  );
}

export default withRouter(TopicTable)